<template>
  <div>
    <h2 class="text-lg leading-6 font-medium text-gray-900 mb-8">Send a test SMS</h2>
    <BaseVeeForm :action="test">
      <!-- formProps
        isIdle, isPending, isResolved, isRejected, invalid
        errors, submit
      -->
      <template #default="formProps">
        <ValidationProvider rules="required|e164phone" name="phone" slim vid="phone">
          <template #default="{ errors }">
            <BaseFormGroup class="max-w-xs">
              <BaseFormInput type="text" v-model="phone" :disabled="formProps.isPending" />
              <BaseFormInlineMessage v-if="errors.length" danger>
                {{ errors[0] }}
              </BaseFormInlineMessage>
            </BaseFormGroup>
          </template>
        </ValidationProvider>
        <div class="mt-8">
          <BaseButton primary outline :disabled="formProps.isPending || formProps.invalid">
            Test
          </BaseButton>
        </div>
        <div v-if="response && response.data" class="mt-5">
          <div class="bg-white border overflow-hidden rounded-lg">
            <div class="px-4 py-5 sm:px-6">
              <h3 class="text-lg leading-6 font-medium text-gray-900">Result</h3>
            </div>
            <div class="border-t border-gray-200">
              <dl>
                <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt class="text-sm font-medium text-gray-500">Total messages</dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {{ totalMessages }}
                  </dd>
                </div>
                <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt class="text-sm font-medium text-gray-500">Total Cost</dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {{ totalCost }}
                  </dd>
                </div>
                <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt class="text-sm font-medium text-gray-500">Error message</dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {{ errorMessage }}
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
        <div v-else-if="response && response.error">
          <p class="text-red-500">
            {{ response.error }}
          </p>
        </div>
      </template>
    </BaseVeeForm>
  </div>
</template>

<script>
import { smsCampaignTestClient } from '@/api/clients';

export default {
  props: {
    smsCampaign: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      phone: '',
      response: null,
    };
  },
  computed: {
    totalMessages() {
      return (this.response?.data?.['message-count'] || []).length;
    },
    totalCost() {
      return (this.response?.data?.messages || [])
        .map((message) => message['message-price'])
        .filter(Boolean)
        .reduce((acc, cur) => acc + Number.parseFloat(cur), 0);
    },
    errorMessage() {
      return this.response?.data?.error || 'No error';
    },
  },
  methods: {
    test() {
      return smsCampaignTestClient
        .test(this.smsCampaign.id, {
          phone: this.phone,
        })
        .then((response) => {
          this.response = response.data;

          return Promise.resolve(response);
        });
    },
  },
};
</script>
